/**
 * API client for backend communication - HTTPS ONLY
 */
import axios from 'axios';

// Always use HTTPS with current hostname
const API_BASE_URL = `https://${window.location.host}/api/v1`;

console.log('🔌 API Base URL:', API_BASE_URL);
console.log('🔌 Current origin:', window.location.origin);
console.log('🔌 Window location host:', window.location.host);
console.log('🔌 Window location protocol:', window.location.protocol);

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  timeout: 30000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
